import React from 'react'

import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';


import { makeSelectEntity } from 'models/selectors';
import { makeSelectIsPayableDomain } from 'containers/App/selectors'
 
import banner from 'images/paybanner.jpg'
import 'css/components/promobanner.sass'

class PromoPaymentBanner extends React.Component {
  constructor(props) {
    super(props)
  }


  render() {
    const { showBanner } = this.props
    // return null
    if(!showBanner) return null
    return (
      <div className='promobanner'>
        <img src={banner}/>
        <div className="promobanner__text">
          Теперь вы можете оплатить заказ online
        </div>
      </div>
    )
  }
}

function mapDispatchToProps (dispatch) {
  return {
  };
}

const mapStateToProps = createStructuredSelector({
  // orderSelector: makeSelectEntity('orders'),
  showBanner: makeSelectIsPayableDomain(),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  withConnect,
)(PromoPaymentBanner);